import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { makeStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'

import Link from 'components/widgets/Link'

//import poolSelectors from 'store/selectors/pool'
import routerSelectors from 'store/selectors/router'

import { handlers } from '../store/utils/api'

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(4),
  },
  toolbar: {
    display: 'flex',
    flexDirection: 'row',
  },
  title: {
    flexGrow: 1,
  }
}))

// TODO: stream logs with messagebus subscribeToPoolLogs

const PoolLogs = () => {
  const classes = useStyles()
  const [ logs, setLogs ] = useState([])
  const params = useSelector(routerSelectors.params)
  
  useEffect(() => {
    // put async code in a func as we can't return a promise directly to
    // useEffect
    var f = async () => {
      setLogs([{text: "Loading..."}])
      console.log(`fetching logs for ${params.id}!`)
      const data = await handlers.get(`/pools/${params.id}/logs`)
      console.log(data)
      if (data.length > 10000) {
        setLogs([{text: "WARNING: Only showing the last 10,000 log lines."}, {text: ""}].concat(data.slice(-10000)))
      } else if (data.length > 0) {
        setLogs(data)
      } else {
        setLogs([{text: "No logs found."}])
      }
    }
    f()
    // TODO return a function that cleans up the websocket if/when we open a
    // websocket above
  }, [params.id]);

  return (
    <div className={ classes.root }>
      <div className={ classes.toolbar }>
        <div className={ classes.title }>
          <Typography gutterBottom variant="h6">
            Pool Logs for { params.id }
          </Typography>
        </div>
      </div>
      <div className={ classes.content }>
        <p><Link name="pools">Pools</Link></p>
        <pre style={{color: "white", backgroundColor: "black", padding: "20px"}}>
        {
          logs.map((line, i) => <div key={i}>{line.text}</div>)
        }
        </pre>
      </div>
    </div>
  )
}

export default PoolLogs
